import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

export function BooleanRadioButtons(props) {
  return (
    <FormControl
      component="fieldset"
      error={props.error}
      variant="standard"
      sx={{ display: "block", m: 1 }}
    >
      <FormLabel component="legend">{props.label}</FormLabel>
      <RadioGroup
        aria-label={props.label}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      >
        <FormControlLabel
          disabled={props.disabled}
          value={true}
          control={<Radio />}
          label="Yes"
        />
        <FormControlLabel
          disabled={props.disabled}
          value={false}
          control={<Radio />}
          label="No"
        />
      </RadioGroup>
      <FormHelperText>{props.helperText}</FormHelperText>
    </FormControl>
  );
}

export function RadioButton(props) {
  return (
    <FormControl
      component="fieldset"
      error={props.error}
      variant="standard"
      sx={{ display: "block", m: 1 }}
    >
      <FormLabel component="legend">{props.label}</FormLabel>
      <RadioGroup
        aria-label={props.label}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      >
        <FormControlLabel
          disabled={props.disabled}
          value={true}
          control={<Radio />}
          label="Yes"
        />
        <FormControlLabel
          disabled={props.disabled}
          value={false}
          control={<Radio />}
          label="No"
        />
        <FormControlLabel
          disabled={props.disabled}
          value="I would like to"
          control={<Radio />}
          label="I would like to"
        />
      </RadioGroup>
    </FormControl>
  );
}

// export default BooleanRadioButtons;
// export default RadioButton;
